import { makeAutoObservable } from "mobx";
import AccountStore from "@stores/AccountStore";
import SettingsStore from "@stores/SettingsStore";
import SeasonStore from "@stores/SeasonStore";
import FarmStore from "@stores/FarmStore";

export default class RootStore {
  public accountStore: AccountStore;
  public settingsStore: SettingsStore;
  public seasonStore: SeasonStore;
  public farmStore: FarmStore;

  constructor() {
    this.accountStore = new AccountStore(this);
    this.settingsStore = new SettingsStore(this);
    this.seasonStore = new SeasonStore(this);
    this.farmStore = new FarmStore(this);
    makeAutoObservable(this);
  }
}
